import vars from '../helpers';
import {aosInit} from "./aos";

const isHome = $('.is-page-home').length;
const $preloader = $('.preloader');
const $preloaderText = $('.preloader__count');
const $preloaderProgress = $('.preloader__progress');
let preloaderCount;
let preloaderCount2;

(function addXhrProgressEvent($) {
	let originalXhr = $.ajaxSettings.xhr;
	$.ajaxSetup({
		progress: function () {
			console.log("standard progress callback");
		},
		xhr: function () {
			let req = originalXhr(), that = this;
			if (req) {
				if (typeof req.addEventListener == "function") {
					req.addEventListener("progress", function (evt) {
						that.progress(evt);
					}, false);
				}
			}
			return req;
		}
	});
})(jQuery);

function showPreloader() {
	$preloader.addClass('hide-preloader');

	setInterval(function () {
		$preloader.addClass('preloader-hidden');
		$('.site').removeClass('height-hidden');
	}, 3000);
}

function loadbar() {
	let img = document.images;
	let c = 0;
	let tot = img.length;
	let totalLottie = 10; // значение увеличить если добавится больше лотти

	if (document.querySelector('.home')) {
		totalLottie = 75;
	}

	let lotties = document.querySelectorAll('.lottie');

	lotties.forEach((element, i) => {
		element.addEventListener('loadedmetadata', calculate(i));

		if (element.readyState >= 2) {
			calculate(i);
		}
	});

	function calculate() {
		c += 1;

		if (c == 2) {
			preload();
		}
	}

	function preload() {
		for (let i = 0; i <= totalLottie; i++) {
			setTimeout(function () {
				let perc = 100 / totalLottie * i << 0;
				if (perc >= 100) {
					perc = 100;
				}

				$preloaderText.html(`${perc}%`);
				$preloaderProgress.css('width', `${perc}%`);

				if (perc >= 100) {
					showPreloader();

					aosInit();
				}
			}, i * 500)
		}
	}

	function imgLoaded() {
		c += 1;
		// let perc = ((100 / tot * c) << 0);
		// let percCalc = (isHome && !vars.isMobile()) ? (perc / 5) : perc;
		// preloaderCount = percCalc;
		//
		// $preloaderText.html(`${percCalc}%`);
		// $preloaderProgress.css('width', `${percCalc}%`);

		if (c === tot) return preload();
	}

	// function doneLoading(){
	// 	if (isHome && !vars.isMobile()) {
	// 		$.ajax(
	// 			{
	// 				url: "./lottie/cloud-1-hover.json",
	// 				type: "GET",
	// 				progress: function(evt) {
	// 					if (evt.lengthComputable) {
	// 						let perc = parseInt((evt.loaded / evt.total * 100), 10);
	// 						let percProgress = preloaderCount;
	// 						let percCalc = percProgress + (perc / 2.5);
	//
	// 						$preloaderProgress.css('width', `${percCalc}%`);
	// 						preloaderCount2 = percCalc;
	//
	// 						console.log(percCalc)
	// 					}
	// 				},
	// 				error: function () {
	// 					console.log('error')
	// 				}
	// 			}
	// 		)
	// 		.then(function() {
	// 			return $.ajax({
	// 				url: "./lottie/cyber-1-hover.json",
	// 				type: "GET",
	// 				progress: function(evt) {
	// 					if (evt.lengthComputable) {
	// 						let perc = parseInt((evt.loaded / evt.total * 100), 10);
	// 						let percProgress = preloaderCount2;
	// 						let percCalc = percProgress + (perc / 2.5);
	//
	// 						console.log(percCalc)
	//
	// 						$preloaderProgress.css('width', `${percCalc}%`);
	// 					}
	// 				},
	// 				complete: function() {
	// 					showPreloader();
	// 				},
	// 			})
	// 		})
	// 	} else {
	// 		showPreloader();
	// 	}
	// }

	for (let i = 0; i < tot; i++) {
		let tImg = new Image();
		tImg.onload = imgLoaded;
		tImg.onerror = imgLoaded;
		tImg.src = img[i].src;
	}
}

function init() {
	document.addEventListener('DOMContentLoaded', loadbar, false);
}

export default {
	init,
};
